import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Tenants/Table";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  BoxTitle,
  BoxContainer,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import EditTenantsModel from "../../Components/Tenants/EditTenants";
import ViewDetailModel from "../../Components/Tenants/ViewDetail";
import Kyc from "../../Components/Tenants/Kyc";
import moment from "moment";
import UploadDocument from "../../Components/Tenants/UploadDocument";
import SummaryCard from "../../Components/Tenants/SummaryCardForBookings";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import NotFoundModel from "../../Components/NotFoundModel";

const Tenants = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const [isFocused, setIsFocused] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("");
  const [editUser, setEditUser] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [uploadDocument, setUploadDocument] = useState(false);
  const [openKYCModel, setOpenKYCModel] = useState(false);
  const [apiData, setApiData] = useState();
  const [summaryData, setSummaryData] = useState({
    totalTenants: 0,
    newTenants: 0,
    verified: 0,
    moveIn: 0,
    moveOut: 0,
    unVerified: 0,
    appNotInstalled: 0,
  });
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(90, "days").format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const { t, i18n } = useTranslation();
  const query = `propId=${property?.id}&searchVal=&filter=${filter}`;

  const initialValues = {
    name: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(90, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/tenant/list/web?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.data === false) error = true;
    else {
      setApiData(res?.data?.list);
      setSummaryData(res?.data?.summary);
      // if (isFocused === false) {
      //   setSummaryData(res?.data?.summary);
      // }
      setIsFocused(true);
    }
  };

  const getError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    if (filter) {
      const handler = setTimeout(() => {
        getListMutate();
      }, 100);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [filter]);

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, [property]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getListMutate();
  };
  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);
  };

  // --------Upload Document---------
  const uploadDocumentFunction = async (values) => {
    const formData = new FormData();
    formData.append("clientId", values.id);
    formData.append("document", values.tenantDocumentImage);

    return await axios.post(`${Config.apiUrl}/uploadDocument`, formData, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "multipart/form-data",
      },
    });
  };

  const onUploadDocumentSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Document uploaded successfully!");
      apiData((prevData) =>
        prevData.map((owner) =>
          owner.id === selectedData.id
            ? { ...owner, documentPath: data.data.documentPath }
            : owner
        )
      );
    } else {
      toast.error(data?.data?.msg || "An error occurred.");
    }
    setUploadDocument(false);
    setSelectedData("");
  };

  const onUploadDocumentError = (error) => {
    toast.error(error?.response?.data?.msg || "An error occurred.");
    setUploadDocument(false);
  };
  const { isLoading: uploadDocumentLoading, mutate: uploadDocumentMutate } =
    useMutation(uploadDocumentFunction, {
      onSuccess: onUploadDocumentSuccess,
      onError: onUploadDocumentError,
    });

  //------- Edit Single Entry -------
  const EditTenantsFunction = async (values) => {
    const body = new FormData();
    body.append("id", values.id);
    body.append("name", values.name);
    body.append("mobile", values.mobile);
    body.append("status", values.status);
    body.append("occupation", values.occupation);
    body.append("gender", values.gender);
    body.append("email", values.email);
    body.append("kycStatus", values.kycStatus);
    body.append("moveInDate", values.moveInDate);
    body.append("agreementStartDate", values.agreementStartDate);
    body.append("rentalCycle", values.rentalCycle);

    return await axios.post(`${Config.apiUrl}/edittenant`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onEditEntrySuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");
      setApiData(data.data);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setEditUser(false);
  };

  const onEditEntryError = (data) => {
    setEditUser(false);
    setSelectedData("");
    toast.error(data?.data?.msg || "An Error Occured");
  };

  const onSummaryBoxClick = (data) => {
    setFilter(data);
  };

  const { isLoading: editEntryLoading, mutate: editTenantsMutate } =
    useMutation(EditTenantsFunction, {
      onSuccess: onEditEntrySuccess,
      onError: onEditEntryError,
    });

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Bookings
            <Underline />
          </BoxTitle>
        </BoxHead>

        {editUser && (
          <EditTenantsModel
            editTenantsMutate={editTenantsMutate}
            editEntryLoading={editEntryLoading}
            setEditUser={setEditUser}
            data={data?.data}
            selectedData={selectedData}
          />
        )}

        {viewDetail && (
          <ViewDetailModel
            setViewDetail={setViewDetail}
            selectedData={selectedData}
          />
        )}

        {uploadDocument && (
          <UploadDocument
            uploadDocumentMutate={uploadDocumentMutate}
            uploadDocumentLoading={uploadDocumentLoading}
            setUploadDocument={setUploadDocument}
            selectedData={selectedData}
            data={data?.data}
          />
        )}

        {openKYCModel && (
          <Kyc setOpenKYCModel={setOpenKYCModel} selectedData={selectedData} />
        )}

        {(isLoading || isRefetching) && !isFocused && (
          <SummarySkeletonLoading count={5} />
        )}
        {isFocused && summaryData && (
          <SummaryCard summaryData={summaryData} onClick={onSummaryBoxClick} />
        )}

        {/* <FiltersTab /> */}

        {!error && !isLoading && apiData && (
          <TableWrapper>
            <Table
              apiData={error ? [] : apiData?.length > 0 ? apiData : []}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              setEditUser={setEditUser}
              setViewDetail={setViewDetail}
              setUploadDocument={setUploadDocument}
              userType={user.userType}
              setOpenKYCModel={setOpenKYCModel}
            />
            {(error || apiData?.length == 0) && !isLoading && <NotFoundModel />}
          </TableWrapper>
        )}
        {(isLoading || isRefetching) && <Loading />}
        {error && !isLoading && <NotFoundModel />}
      </BoxContainer>
    </>
  );
};


const TableWrapper = tw.h1`my-8 border  bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const UploadWrapper = tw.div`w-full flex justify-end space-x-4 items-center `;
// export const FieldWrapper = tw.div`
// ${(p) => (p.$select ? "" : "pl-2  field-wrapper border border-gray-300")}
//  relative  rounded-md   w-full  flex items-center`;
const FilterContainer = tw.div`
grid grid-cols-2 w-full gap-4 md:flex md:space-x-4 items-end mt-0 md:mt-0`;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color py-[.550rem] text-sm`;
export default Tenants;
